import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { getOrCreateAuditSessionCorrelationId } from "../services/audit-session.storage";

/** Sends the audit tab session id on API calls for server-side correlation. */
export const auditCorrelationInterceptor: HttpInterceptorFn = (req, next) => {
  const base = environment.apiBaseUrl.replace(/\/$/, "");
  const url = req.url.split("?")[0];
  if (!url.startsWith(base)) {
    return next(req);
  }

  const correlationId = getOrCreateAuditSessionCorrelationId();
  return next(
    req.clone({
      setHeaders: { "X-Correlation-Id": correlationId },
    }),
  );
};
